@if (isCheckbox) {
  <div>
    <form-checkbox
      [disabled]="disabled"
      [checked]="checked"
      (checkedChange)="handleCheckChange()"
    ></form-checkbox>
  </div>
} @else {
  <div>{{ header }}</div>
}
